<script setup lang="ts">
withDefaults(defineProps<{ variant?: 'primary' | 'secondary' | 'ghost'; type?: 'button' | 'submit'; disabled?: boolean }>(), {
  variant: 'primary',
  type: 'button',
  disabled: false
})
</script>

<template>
  <button :type="type" class="ck-button" :class="`ck-button--${variant}`" :disabled="disabled"><slot /></button>
</template>

<style scoped>
.ck-button { display: inline-flex; align-items: center; justify-content: center; gap: var(--space-2); border: 0; border-radius: var(--radius-md); padding: 11px 18px; min-height: 44px; font-weight: var(--fw-bold); line-height: 1.2; cursor: pointer; transition: transform 200ms ease-out, background 200ms ease-out, box-shadow 200ms ease-out; }
.ck-button--primary { color: white; background: var(--ck-orange-500); box-shadow: var(--shadow-flame); }
.ck-button--primary:hover { background: var(--ck-orange-600); }
.ck-button--secondary { color: var(--ck-maroon-700); background: var(--ck-cream-200); border: 1px solid var(--ck-cream-300); }
.ck-button--ghost { color: inherit; background: transparent; }
.ck-button:focus-visible { outline: 3px solid color-mix(in srgb, var(--ck-orange-500) 45%, transparent); outline-offset: 2px; }
.ck-button:active { transform: scale(.98); }
.ck-button:disabled { cursor: not-allowed; opacity: .55; box-shadow: none; }

@media (prefers-reduced-motion: reduce) {
  .ck-button { transition: none; }
}
</style>
